import {BaseComponent} from "../BaseComponent/BaseComponent";
export default BaseComponent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/BaseComponent/index.ts